$(() => {
    setupCRMNote();

    const crm = new CRM();

    crm.setupNextActionSelect();

});


class CRM {

    setupNextActionSelect() {
        $('#crm-next-action-select').on('change', function() {

            $.post({ 
                "url": $(this).data('url'),
                "data": {action: $(this).val()},
                success: (data) => 
                {
                    if(!data.isSuccess) { return false; }
                
                    $('#next-action-message').text("Uloženo");
                    setTimeout(() => {
                        $('#next-action-message').text("");
                    }, 1000)
                },
            });

        });
    }

}










let setupCRMNote = () => 
{
    const mdConvertor = new MDConvertor();
    setupFormEvents();

    let setupNoteEditation = () => 
    {
        let fillEditationFormWithData = (noteId) => 
        {
            let noteInfo = $('.crm-note-' + noteId );

            $('#crmNoteId').val(noteId);

            let formName = '#frm-CrmNoteForm-form-';

            $(formName + 'type option[value="' + noteInfo.attr('data-type') + '"]').prop("selected", true);
            $(formName + 'crmPersonId option[value="' + noteInfo.attr('data-crmpersonid') + '"]').prop("selected", true);

            let convertedText = mdConvertor.convertHtmlToMd(noteInfo.attr('data-text'));
            $(formName + 'text').val(convertedText);
            $(formName + 'workTime').val(noteInfo.attr('data-worktime'));
        }

        let setupEditationForm = (noteId) => 
        {
            let form  = $('#CRMNoteFormContainer').html();
            $('#CRMNoteFormContainer').html("");

            $('#addCRMNoteButton').hide();
            $('.edit-crm-note').hide();


            $('.note-row-' + noteId + ' .wrapper').hide();

            $('.cancel-container-' + noteId).css('display', 'block');
            $('.note-row-' + noteId + ' .form .form-container').html(form); 

            setupFormEvents();
        }


        $('.edit-crm-note').on('click', (event) => 
        {
            let noteId = $(event.target).attr('data-noteId');

            setupEditationForm(noteId);
            fillEditationFormWithData(noteId);
        });

        
        $('.cancel-note-editing').on('click', (event) => 
            {
                let noteId = $(event.target).attr('data-noteId');

                let form  = $('.note-row-' + noteId + ' .form .form-container').html();
                $('#CRMNoteFormContainer').html(form);

                $('#addCRMNoteButton').show();
                $('.edit-crm-note').show();


                $('.note-row-' + noteId + ' .form .form-container').html(""); 
                $('.cancel-container-' + noteId).css('display', 'none');

                $('.note-row-' + noteId + ' .wrapper').show();


                $('#crmNoteId').val(null);

                setupFormEvents();

            });
    }

    function setupFormEvents() {
    
        $('.btnSave').on('click', function(e) {    
            const text = $('#frm-CrmNoteForm-form-text').val();
            const convertedText = mdConvertor.convertMdToHtml(text);
            
            $('#frm-CrmNoteForm-form-text').val(convertedText);
        });
    

    }



    let setupNextContactDateInput = () => 
    {
        $('#frm-CrmNoteForm-form-nextContactDate').on('change', () => 
        {
            $('.btn-save-other').hide();
            $('.btn-save-group').removeClass('btn-group');
        });
    
        $('.js-cancel').on('click', () => 
        {
            $('.btn-save-other').show();
            $('.btn-save-group').addClass('btn-group');
        });
    }


    setupNextContactDateInput();
    setupNoteEditation();
}